import Nav from "./nav";

function Header() {
  return (
    <header className="  bg-gray-200 bg-opacity-30 backdrop-blur-[10px] sticky top-0 z-20  w-full ">
      <Nav />
    </header>
  );
}

export default Header;
